export default __webpack_public_path__ + "static/media/458.bbc9cec4.jpg";